import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { READ_ALL_AVAILABLE_STATUSES } from "../actions/types"

import {
  readAllStatusesSuccess,
  readAllStatusesError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request() {
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/statuses`,
      params: {
        limit: -1,
      },
    })

    yield put(readAllStatusesSuccess(response))
  } catch (error) {
    yield put(readAllStatusesError(error))
  }
}

export default function* allStatusesSaga() {
  yield takeEvery(READ_ALL_AVAILABLE_STATUSES, request)
}
